import Swiper, { A11y, EffectFade } from 'swiper';

import '../../sass/blocks/office-map.scss';

( () => {
    const $officeMaps = document.querySelectorAll('.office-map');

    if ( !$officeMaps ) return;

    $officeMaps.forEach( $officeMap => {
        const $addressesSlider = $officeMap.querySelector('.office-map__addresses');
        const $navBtns = $officeMap.querySelectorAll('.office-map__nav-btn');
        const $map = $officeMap.querySelector('.office-map__map-inner');
        let map;
        let mapMarker;
        let slider;

        const initAddressSlider = () => {
            if ( !$addressesSlider ) return;

            slider = new Swiper($addressesSlider, {
                modules: [ A11y, EffectFade ],
                allowTouchMove: false,
                a11y: {},
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
            });
        };

        const setMapMarker = (lat, lng) => {
            if ( !map || !lat || !lng ) return;

            const mapLatLng = { lat: parseFloat(lat), lng: parseFloat(lng) };

            if ( mapMarker ) {
                mapMarker.setMap(null);
            }

            map.panTo(mapLatLng);

            mapMarker = new google.maps.Marker({
                position: mapLatLng,
                map,
                draggable: false,
                icon: {
                    path: "M53 26.47a26.5 26.5 0 0 0-53 0C0 46.32 26.5 75 26.5 75S53 46.32 53 26.47Zm-35.33 0a8.85 8.85 0 0 1 8.83-8.82 8.83 8.83 0 1 1-8.83 8.82Z",
                    fillColor: '#F05423',
                    fillOpacity: 1,
                    size: new google.maps.Size(53, 75),
                    anchor: new google.maps.Point(26.5, 75),
                    strokeWeight: 0,
                    scale: 1
                }
            });
        };

        const initMap = () => {
            if ( !$map || !$navBtns ) return;

            const { officeLat, officeLng } = $navBtns[0].dataset;

            map = new google.maps.Map($map, {
                zoom: 16,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            });

            setMapMarker(officeLat, officeLng);

            $navBtns[0].classList.add('active');

            $navBtns.forEach( $navBtn => {
                $navBtn.addEventListener( 'click', () => {
                    const { officeIndex, officeLat, officeLng } = $navBtn.dataset;

                    if ( !officeIndex ) return;

                    setMapMarker(officeLat, officeLng);

                    const $activeNavBtn = $officeMap.querySelector('.office-map__nav-btn.active');

                    if ( $activeNavBtn ) {
                        $activeNavBtn.classList.remove('active');
                    }

                    $navBtn.classList.add('active');

                    slider.slideTo(officeIndex);
                } );
            } );
        };

        window.addEventListener('load', () => {
            initMap();
            initAddressSlider();
        });
    } );
} )();
